// This controller borrows from toggle_controller.js and does some additional stuff specific to
// multi-select.

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display", "overlay", "content"];
  // Optional labels for the boundary states.
  //   allLabel  — shown when *every* checkbox is checked. Set via
  //               `data-multi-select-all-label-value="..."`. Falls back to
  //               the normal comma-joined list.
  //   noneLabel — shown when *no* checkbox is checked. Set via
  //               `data-multi-select-none-label-value="..."`. Falls back to
  //               the literal "All" for backward compat with existing
  //               multi-selects that treat empty as "no filter applied".
  static values = { allLabel: String, noneLabel: String };

  connect() {
    this.update();
  }

  toggle(e) {
    // Determine current state before toggling
    const wasOpen = !this.overlayTarget.classList.contains("hidden");

    // There's a limitation in height animations, which is nothing to do with Tailwind, just CSS.
    // If you want to animate, you have to have a specific start and end size. To make this happen
    // we use a viewport-based max-height which should be big enough to accommodate the content
    this.contentTarget.classList.toggle("max-h-0");
    this.contentTarget.classList.toggle("max-h-[80vh]");

    this.overlayTarget.classList.toggle("hidden");

    // Elevate the root container above sibling filters while open so the
    // dropdown can escape the parent's stacking context. Keep it elevated
    // until the close animation finishes to avoid brief wrong stacking.
    if (!wasOpen) {
      // Opening now
      this.element.classList.add("z-50");
    } else {
      // Closing now: wait for transition to complete before dropping z-index
      const onTransitionEnd = (event) => {
        if (event.target !== this.contentTarget) return;
        this.element.classList.remove("z-50");
      };
      this.contentTarget.addEventListener("transitionend", onTransitionEnd, { once: true });
    }
  }

  update(e) {
    var display = "";
    var checkboxes = this.element.querySelectorAll("input[type=checkbox]");
    var checkedCount = 0;
    for (var i = 0; i < checkboxes.length; i++) {
      if (checkboxes[i].checked) {
        checkedCount++;
        if (display.length > 0) {
          display += ", ";
        }

        const label = checkboxes[i].dataset.label || checkboxes[i].value;
        display += label;
      }
    }

    if (checkedCount === checkboxes.length && checkboxes.length > 0 && this.allLabelValue) {
      display = this.allLabelValue;
    } else if (checkedCount === 0) {
      display = this.noneLabelValue || "All";
    }

    this.displayTarget.value = display;
  }
}
